export const MAX_ITEMS = 5;
export const DISCLAIMER_TEXT = `We’re experimenting with a new recommendation system that will offer a better way to browse and discover content that interests you.`;
export const REC_FOR_YOU_TITLE = "Recommended for you";

export const REC_FOR_YOU_FEATURE_INSTANCE = "rec-sys";
